<table class="table-calendar day-mode">
	<thead>
		<tr
			(click)="calendarUtils.showEventsOfDay(activeDate.date, showDayEvents)"
			class="day-header"
			[ngClass]="{ currentDayVisible: currentDayVisible }"
		>
			<td colspan="2" [ngClass]="{ currentDayVisible: currentDayVisible }">
				{{ activeDate.weekDayFullName | uppercase }}
				<span class="badge" data-day="0">{{ dayTotalEvents }}</span>
			</td>
		</tr>
	</thead>

	<tbody data-item="day-content" [@tableAnimation]>
		<tr>
			<td colspan="2" style="padding: 0">
				<div
					*ngIf="isLoading"
					style="margin-top: 60px; padding: 50px 20px; text-align: center"
				>
					<freud-loader size="sm" [bgColor]="false"></freud-loader>
				</div>

				<div
					*ngIf="!isLoading"
					id="calendar-scroll-container"
					class="scroll-container"
				>
					<table
						class="table-calendar day-mode"
						style="border: none; height: 0; position: relative"
					>
						<tbody>
							<tr
								class="innerRow"
								*ngFor="let hour of hours; let i = index"
								id="dh{{ hour.hour }}"
							>
								<td
									class="td-no-border"
									style="width: 40px; vertical-align: top"
								>
									<div
										class="{{
											i > 0 && !hour.isHalfHour ? 'day-hour' : 'day-hour-hidden'
										}} {{
											currentDayVisible && hour.hour == hourIntervalNow
												? 'rowOfNow'
												: ''
										}}"
									>
										{{ hour.hour }}
									</div>
									<div
										class="line-hour-circle"
										*ngIf="currentDayVisible && hour.hour == hourIntervalNow"
									></div>
								</td>
								<td
									class="day-events-container"
									[ngClass]="{
										rowOfNow: currentDayVisible && hour.hour == hourIntervalNow
									}"
								>
									<div
										*ngFor="let event of hour.events"
										class="td-container {{ event.status }} online-session"
										[ngStyle]="{
											height: event.calendarHeight,
											top: event.calendarOffset,
											left: hour.hasRecurrencyOverlaping ? '30px' : '0px'
										}"
										(click)="
											calendarUtils.openDetailsModal(
												event.id,
												'event',
												showSelectedEvent,
												event
											)
										"
									>
										<div class="day-event-item">
											<p class="sec-title">
												<fa-icon
													*ngIf="
														event.status === 'paid' &&
														event.contactReason &&
														event.contactReason.length === 0
													"
													icon="circle"
													class="no-contact-reason"
													pTooltip="{{
														'TOOLTIPS.APPOINTMENTS.REASON' | translate
													}}"
													tooltipPosition="top"
												></fa-icon>
												{{
													event.status !== 'reserved'
														? event.userName
														: ('GENERAL.PENDING' | translate)
												}}
											</p>
											<p class="sec-subtitle ev-{{ event.status }}">
												<calendar-event-icon
													[status]="event.status"
													[userRequestedReschedule]="
														event.userRequestedReschedule
													"
												></calendar-event-icon>
												{{ event.statusText }}
											</p>
										</div>
									</div>
									<div
										*ngFor="let busySlot of hour.busySlots"
										class="td-container calendar-event personal-session"
										[ngStyle]="{
											height: busySlot.calendarHeight,
											top: busySlot.calendarOffset,
											left: hour.hasRecurrencyOverlaping ? '30px' : '0px'
										}"
										(click)="
											calendarUtils.openDetailsModal(
												busySlot.id,
												'busyslot',
												showSelectedEvent
											)
										"
									>
										<div *ngIf="!isMobile" class="day-event-item">
											<p class="sec-title">
												{{ busySlot?.description }}
											</p>
										</div>
									</div>
									<calendar-slot-recurency-attempt
										*ngFor="let recurrencyAttempt of hour.recurrencyAttempts"
										[recurrencyAttempt]="recurrencyAttempt"
										(onOpenDetails)="
											calendarUtils.openDetailsModal(
												$event.overlapEventId,
												$event.reason === 'DatetimeReservedForAnotherSession'
													? 'event'
													: 'busyslot',
												showSelectedEvent
											)
										"
									></calendar-slot-recurency-attempt>
									<div
										class="slot-without-events"
										[ngClass]="{
											slotAvailable:
												calendarAvailabilitiesService.isSlotAvailable(
													avaibilitiesForDay,
													hour.luxonDate
												),
											slotUnavailable:
												!calendarAvailabilitiesService.isSlotAvailable(
													avaibilitiesForDay,
													hour.luxonDate
												)
										}"
										(click)="
											calendarUtils.createEvent(
												hour.luxonDate,
												showSelectedEvent
											)
										"
									></div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</td>
		</tr>
	</tbody>
</table>
